import { OAuthModule, OAuthService } from 'angular-oauth2-oidc';

import { IAuthStrategy } from '@sondermind/utilities/models-auth';

import { AuthInterceptor } from './interceptors/auth_interceptor';
import { AuthTokenService } from './services/auth_token.service';
import { AuthTokenOAuthService } from './services/auth_token_oauth.service';

/**
 * The authentication strategy intended for standalone web applications
 * who are not hosted within another application.
 *
 * This strategy implements the OAuth2 implicit auth flow.
 *
 * *See [readme](../../README.md) for more details.*
 */
export const HOST_AUTH_STRATEGY: IAuthStrategy<AuthTokenService, AuthInterceptor> = {
  authService: AuthTokenService,
  authHttpInterceptor: AuthInterceptor,
  dependencies: [
    ...OAuthModule.forRoot().providers || [],
    AuthTokenOAuthService,
    { provide: OAuthService, useExisting: AuthTokenOAuthService }
  ]
};
